// @ts-nocheck
import { vueAppWithStore } from "../Common/vueApp";
import CreateNotificationApp from "../NotificationsCenter/CreateNotificationApp.vue";
import Vuex from "vuex";
import { NOTIFICATION_NONE, STEP_CHOOSE_SOURCE_EVENTS, NOTIFICATION_EMAIL, NOTIFICATION_INTERNAL } from "./consts";
import sessionStorage from "../Common/sessionStore";
import { promiseRequestFactory, requestMutations, requestState } from "../Common/Vuex/request";
import notificationsCenterApi from "../Api/notificationsCenter";
import { isValidEmailAndNotEmpty } from "../Common/email";
import debounce from "lodash.debounce";
function storeKey(key) {
    return "createNotification." + key;
}

export const PAYMENT_NONE = 0;
export const PAYMENT_AT_LEAST_ONE_COMPLETE = 1;
export const PAYMENT_AT_LEAST_ONE_MISSING = 2;

export const PAGE_CURSOR_ASC = "asc";
export const PAGE_CURSOR_DESC = "desc";

const STORE_CURRENT_STEP = "currentStep";
const STORE_SELECTED_EVENTS = "selectedEvents";
const STORE_FILTER_COUNTRIES = "filterCountries";
const STORE_FILTER_PAYMENT = "filterPayment";
const STORE_TYPE_OF_NOTIFICATION = "typeOfNotification";
const STORE_NOTIFICATION_MESSAGE = "notificationMessage";
const STORE_DELAY_IN_SEC = "delayInSec";
const STORE_EMAIL_REPLY_TO = "emailReplyTo";
const STORE_PHONE_REPLY_TO = "phoneReplyTo";
const STORE_NAME_REPLY_TO = "nameReplyTo";

export const store = new Vuex.Store({
    modules: {
        main: {
            namespaced: true,
            state: {
                userCountryCode: "",
                activeStep: STEP_CHOOSE_SOURCE_EVENTS,
            },
            mutations: {
                setUserCountryCode(state, payload) {
                    state.userCountryCode = payload;
                },
                setActiveStep(state, payload) {
                    sessionStorage.set(storeKey(STORE_CURRENT_STEP), payload);
                    state.activeStep = payload;
                },
                loadActiveStepFromStorage(state) {
                    const fromStore = sessionStorage.get(storeKey(STORE_CURRENT_STEP));

                    if (!fromStore) {
                        return;
                    }

                    state.activeStep = fromStore;
                },
            },
            getters: {
                allStepsCompleted(state, getters, rootState, rootGetters) {
                    return (
                        rootGetters["choosingSourceEvents/isStepComplete"] &&
                        rootGetters["typeOfNotification/isStepComplete"] &&
                        rootGetters["notificationContent/isStepComplete"] &&
                        rootGetters["scheduleTime/isStepComplete"]
                    );
                },
            },
            actions: {
                clearWholeLocalStorage() {
                    sessionStorage.delete(storeKey(STORE_SELECTED_EVENTS));
                    sessionStorage.delete(storeKey(STORE_TYPE_OF_NOTIFICATION));
                    sessionStorage.delete(storeKey(STORE_EMAIL_REPLY_TO));
                    sessionStorage.delete(storeKey(STORE_PHONE_REPLY_TO));
                    sessionStorage.delete(storeKey(STORE_NAME_REPLY_TO));
                    sessionStorage.delete(storeKey(STORE_FILTER_PAYMENT));
                    sessionStorage.delete(storeKey(STORE_FILTER_COUNTRIES));
                    sessionStorage.delete(storeKey(STORE_NOTIFICATION_MESSAGE));
                    sessionStorage.delete(storeKey(STORE_DELAY_IN_SEC));
                },
            },
        },
        choosingSourceEvents: {
            namespaced: true,
            state: {
                ...requestState,
                calculatedEmails: 0,
                calculatedPhones: 0,
                calculatedUserIds: 0,

                selectedEvents: [],
            },
            mutations: {
                ...requestMutations,
                addEvent(state, payload) {
                    if (state.selectedEvents.includes(payload)) {
                        return;
                    }

                    state.selectedEvents.push(payload);
                    sessionStorage.setObject(storeKey(STORE_SELECTED_EVENTS), state.selectedEvents);
                },
                removeEvent(state, payload) {
                    state.selectedEvents = state.selectedEvents.filter(eventId => eventId !== payload);
                    sessionStorage.setObject(storeKey(STORE_SELECTED_EVENTS), state.selectedEvents);
                },
                loadSelectedEventsFromStorage(state) {
                    const eventsArray = sessionStorage.getObject(storeKey(STORE_SELECTED_EVENTS));

                    if (Array.isArray(eventsArray)) {
                        state.selectedEvents = eventsArray;
                    }
                },
                setEmails(state, payload) {
                    state.calculatedEmails = payload;
                },
                setPhones(state, payload) {
                    state.calculatedPhones = payload;
                },
                setUserIds(state, payload) {
                    state.calculatedUserIds = payload;
                },
                reset(state) {
                    sessionStorage.delete(storeKey(STORE_SELECTED_EVENTS));
                    state.selectedEvents = [];
                    state.calculatedEmails = 0;
                    state.calculatedPhones = 0;
                    state.calculatedUserIds = 0;
                },
            },
            getters: {
                isSelected: state => eventId => {
                    return state.selectedEvents.find(storedEventId => storedEventId === eventId);
                },
                isStepComplete: state => {
                    return state.selectedEvents.length > 0;
                },
            },
            actions: {
                chooseEvent(context, payload) {
                    context.commit("addEvent", payload);
                    return context.dispatch("refreshCalculations");
                },
                removeEvent(context, payload) {
                    context.commit("removeEvent", payload);
                    return context.dispatch("refreshCalculations");
                },
                //Why debouce? Choosing event happens on SourceEvent component level, each rendering
                //triggers checkbox, and setting checkbox triggers this event.
                //The more events selected, the more requests we more when source events step is opened.
                refreshCalculations: debounce(function (context) {
                    return notificationsCenterApi
                        .init(promiseRequestFactory(context))
                        .calculateReceiversForEvents(context.state.selectedEvents)
                        .then(calculatedEvents => {
                            context.commit("setPhones", calculatedEvents.phones);
                            context.commit("setEmails", calculatedEvents.emails);
                            context.commit("setUserIds", calculatedEvents.userIds);
                        });
                }, 100),
            },
        },
        typeOfNotification: {
            namespaced: true,
            state: {
                mainType: NOTIFICATION_NONE,
                emailReplyTo: "",
                phoneReplyTo: "",
                nameReplyTo: "",
            },
            getters: {
                isStepComplete: (state, getters) => {
                    if (state.mainType === NOTIFICATION_NONE) {
                        return false;
                    }

                    if (state.mainType === NOTIFICATION_EMAIL) {
                        return getters.isValidStateForEmailType;
                    }

                    if (state.mainType === NOTIFICATION_INTERNAL) {
                        return getters.isValidStateForInternalType;
                    }

                    return false;
                },
                isValidStateForEmailType: state => isValidEmailAndNotEmpty(state.emailReplyTo),
                isValidStateForInternalType: state => {
                    if (state.nameReplyTo === "") {
                        return false;
                    }

                    return isValidEmailAndNotEmpty(state.emailReplyTo) || !!state.phoneReplyTo;
                },
                isValidEmailAndNotEmpty: state => isValidEmailAndNotEmpty(state.emailReplyTo),
            },
            mutations: {
                setEmailReplyTo(state, payload) {
                    sessionStorage.set(storeKey(STORE_EMAIL_REPLY_TO), payload);
                    state.emailReplyTo = payload;
                },
                setPhoneReplyTo(state, payload) {
                    sessionStorage.set(storeKey(STORE_PHONE_REPLY_TO), payload);
                    state.phoneReplyTo = payload;
                },
                setNameReplyTo(state, payload) {
                    sessionStorage.set(storeKey(STORE_NAME_REPLY_TO), payload);
                    state.nameReplyTo = payload;
                },
                setMainType(state, payload) {
                    sessionStorage.set(storeKey(STORE_TYPE_OF_NOTIFICATION), payload);
                    state.mainType = payload;
                },
                loadTypeOfNotificationFromStorage(state) {
                    const typeOfNotification = sessionStorage.get(storeKey(STORE_TYPE_OF_NOTIFICATION));

                    if (typeOfNotification) {
                        state.mainType = typeOfNotification;
                    } else {
                        state.mainType = NOTIFICATION_NONE;
                    }

                    state.emailReplyTo = sessionStorage.get(storeKey(STORE_EMAIL_REPLY_TO));
                    state.phoneReplyTo = sessionStorage.get(storeKey(STORE_PHONE_REPLY_TO));
                    state.nameReplyTo = sessionStorage.get(storeKey(STORE_NAME_REPLY_TO));
                },
                reset(state) {
                    sessionStorage.delete(storeKey(STORE_EMAIL_REPLY_TO));
                    sessionStorage.delete(storeKey(STORE_PHONE_REPLY_TO));
                    sessionStorage.delete(storeKey(STORE_NAME_REPLY_TO));
                    sessionStorage.delete(storeKey(STORE_TYPE_OF_NOTIFICATION));
                    state.mainType = NOTIFICATION_NONE;
                },
            },
        },
        filteringReceivers: {
            namespaced: true,
            state: {
                ...requestState,
                selectedCountries: [],
                paymentStatus: 0,

                users: 0,
                emails: 0,
                phones: 0,
            },
            mutations: {
                ...requestMutations,
                setUsers(state, payload) {
                    state.users = payload;
                },
                setEmails(state, payload) {
                    state.emails = payload;
                },
                setPhones(state, payload) {
                    state.phones = payload;
                },
                setSelectedCountries(state, payload) {
                    state.selectedCountries = payload;
                    sessionStorage.setObject(storeKey(STORE_FILTER_COUNTRIES), state.selectedCountries);
                },
                loadSelectedCountriesFromStorage(state) {
                    const value = sessionStorage.getObject(storeKey(STORE_FILTER_COUNTRIES));
                    if (Array.isArray(value)) {
                        state.selectedCountries = value;
                    }
                },
                setPaymentStatus(state, payload) {
                    state.paymentStatus = payload;
                    sessionStorage.setInt(storeKey(STORE_FILTER_PAYMENT), payload);
                },
                loadPaymentStatusFromStorage(state) {
                    state.paymentStatus = sessionStorage.getInt(storeKey(STORE_FILTER_PAYMENT));
                },
                reset(state) {
                    sessionStorage.delete(storeKey(STORE_FILTER_PAYMENT));
                    sessionStorage.delete(storeKey(STORE_FILTER_COUNTRIES));
                    state.users = 0;
                    state.phones = 0;
                    state.emails = 0;
                    state.selectedCountries = [];
                    state.paymentStatus = 0;
                },
            },
            actions: {
                resetFilters(context) {
                    context.commit("setSelectedCountries", []);
                    context.commit("setPaymentStatus", 0);

                    return context.dispatch("getSearchSummary");
                },
                getSearchSummary(context) {
                    if (context.rootState.choosingSourceEvents.selectedEvents.length === 0) {
                        return Promise.resolve();
                    }

                    return notificationsCenterApi
                        .init(promiseRequestFactory(context))
                        .getSearchSummary(
                            context.rootState.choosingSourceEvents.selectedEvents,
                            context.state.selectedCountries,
                            context.state.paymentStatus,
                        )
                        .then(response => {
                            context.commit("setUsers", response.users);
                            context.commit("setEmails", response.emails);
                            context.commit("setPhones", response.phones);
                        });
                },
            },
        },
        notificationContent: {
            namespaced: true,
            state: {
                message: "",
            },
            mutations: {
                setMessage(state, payload) {
                    sessionStorage.set(storeKey(STORE_NOTIFICATION_MESSAGE), state.message);
                    state.message = payload;
                },
                loadMessageFromStorage(state) {
                    const message = sessionStorage.get(storeKey(STORE_NOTIFICATION_MESSAGE));

                    if (message) {
                        state.message = message;
                    } else {
                        state.message = "";
                    }
                },
                reset(state) {
                    sessionStorage.delete(storeKey(STORE_NOTIFICATION_MESSAGE));
                    state.message = "";
                },
            },
            getters: {
                isStepComplete: state => state.message.length > 0,
            },
        },
        costCalculation: {
            namespaced: true,
            state: {
                ...requestState,
                numberOfReceivers: 0,
                formattedTotalPrice: "0",
                formattedPriceForType: "0",
            },
            mutations: {
                ...requestMutations,
                setNumberOfReceivers(state, payload) {
                    state.numberOfReceivers = payload;
                },
                setFormattedTotalPrice(state, payload) {
                    state.formattedTotalPrice = payload;
                },
                setFormattedPriceForType(state, payload) {
                    state.formattedPriceForType = payload;
                },
                reset(state) {
                    state.numberOfReceivers = 0;
                    state.formattedTotalPrice = "0";
                    state.formattedPriceForType = "0";
                },
            },
            actions: {
                calculateCost(context) {
                    if (context.rootState.choosingSourceEvents.selectedEvents.length === 0) {
                        return Promise.resolve();
                    }

                    return notificationsCenterApi
                        .init(promiseRequestFactory(context))
                        .calculateCost(
                            context.rootState.typeOfNotification.mainType,
                            context.rootState.choosingSourceEvents.selectedEvents,
                            context.rootState.filteringReceivers.selectedCountries,
                            context.rootState.filteringReceivers.paymentStatus,
                        )
                        .then(resp => {
                            context.commit("setNumberOfReceivers", resp.numberOfReceivers);
                            context.commit("setFormattedTotalPrice", resp.formattedTotalPrice);
                            context.commit("setFormattedPriceForType", resp.formattedPriceForType);
                        });
                },
            },
        },
        scheduleTime: {
            namespaced: true,
            state: {
                chosenDelayInSec: 0,
            },
            mutations: {
                setChosenDelayInSec(state, payload) {
                    sessionStorage.setInt(storeKey(STORE_DELAY_IN_SEC), payload);
                    state.chosenDelayInSec = payload;
                },
                loadDelayFromStorage(state) {
                    state.chosenDelayInSec = sessionStorage.getInt(storeKey(STORE_DELAY_IN_SEC));
                },
                reset(state) {
                    sessionStorage.delete(storeKey(STORE_DELAY_IN_SEC));
                    state.chosenDelayInSec = 0;
                },
            },
            getters: {
                isStepComplete: state => state.chosenDelayInSec > 0,
            },
        },
    },
});

export default vueAppWithStore(CreateNotificationApp, store);
